import { render, staticRenderFns } from "./WorkerConfig.vue?vue&type=template&id=675ed990&scoped=true&"
import script from "./WorkerConfig.vue?vue&type=script&lang=js&"
export * from "./WorkerConfig.vue?vue&type=script&lang=js&"
import style0 from "./WorkerConfig.vue?vue&type=style&index=0&id=675ed990&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ed990",
  null
  
)

export default component.exports